import { theme, TreeView } from '@primer/react';
import ThemeReferenceTree from "../../../../components/ThemeReferenceTree";
import * as React from 'react';
export default {
  theme,
  TreeView,
  ThemeReferenceTree,
  React
};